import { Button, TextField } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import useNotification from '../../../hooks/useNotification';
import { postSCDetails } from '../../../features/student/studentSlice';
import api from '../../../services/api';
import ToastNotification from '../../UIElements/ToastNotification';
import { SCIdCheck } from '../../../features/history/HistorySlice';
const initialData = {
  studentId: '',
  studentName: '',
  guardianName: '',
  className: '',
  academicYear: '',
  conduct: '',
  scDate: '',
};

export const ValidationSchema = Yup.object({
  studentId: Yup.string().required('Student ID is required'),
  studentName: Yup.string().required('Student name is required'),
  guardianName: Yup.string().required('Guardian name is required'),
  className: Yup.string().required('Class name is required'),
  academicYear: Yup.string().required('Academic year is required'),
  scDate: Yup.string().required('Date of Issuing is required'),
  conduct: Yup.string().required('Conduct is required'),
});
export default function SCJuniorCollegeEmpty({ StudentId = '' }) {
  const [data, setData] = useState({ ...initialData });
  const dispatch = useDispatch();
  const [studentId, setStudentId] = useState('');
  const [isIdExists, setIsIdExists] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const { notification, showSuccess, showError, hideNotification } =
    useNotification();
  async function downloadSC(searchParameters) {
    try {
      setIsDownloading(true);
      const fileResponse = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `sc/download/${studentId}`,
        method: 'GET',
        responseType: 'blob',
        headers: searchParameters,
      });
      const blob = new Blob([fileResponse?.data], {
        type: fileResponse.headers['content-type'],
      });
      let filename = `${studentId}-SC.pdf`;
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      showError('Error in Downloading the Study Certificate .');
      console.error('Download failed', err);
    } finally {
      setIsDownloading(false);
    }
  }
  useEffect(() => {
    setStudentId(StudentId);
  }, [StudentId]);
  return (
    <div>
      <Formik
        initialValues={data}
        validationSchema={ValidationSchema}
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        onSubmit={async (values) => {
          try {
            setIsSubmitting(true);
            const resp = await dispatch(postSCDetails(values)).unwrap();
            if (resp.status === 200) {
              setData(resp.data);
              setStudentId(resp.data.studentId);
              showSuccess('Study Certificate details submitted successfully.');
            }
          } catch (error) {
            console.log(error);
            showError('Error in submitting the details.');
          } finally {
            setIsSubmitting(false);
          }
        }}
      >
        {({ values }) => (
          <Form>
            <div className='relative  mx-auto  border py-4 px-14 rounded-md bg-white text-[#1e3a8a]'>
              {/* TOP */}
              {(isSubmitting || isDownloading) && (
                <div className='absolute inset-0 z-10 flex items-center justify-center bg-white/80 opacity-80'>
                  <span className='text-lg font-semibold '>
                    {isSubmitting ? 'Submitting...' : 'Downloading...'}
                  </span>
                </div>
              )}
              <div className='flex flex-col   text-center gap-0'>
                <h2 className='font-bold'>SRI VEERISETTY JUNIOR COLLEGE</h2>
                <h6>
                  <b className='font-bold'>Podili</b>,Prakasam Dist. Pin:523112
                </h6>
                <h6>(Recognised by A.P Government)Rc.No. 149/E2-4/1994-1995</h6>
                <div className='flex justify-center mt-2'>
                  {' '}
                  <h4 className='border-2 p-1 px-2 rounded-lg w-fit border-black font-bold'>
                    STUDY AND CONDUCT CERTIFICATE
                  </h4>
                </div>
              </div>
              <div className='flex-wrap gap-2 text-[20px] leading-10'>
                {/* Addmission Number */}
                <div className='flex gap-1'>
                  Ad.No/Std Id :{' '}
                  {data?.studentId ? (
                    <b className='text-red-500'> {data?.studentId}</b>
                  ) : (
                    <div>
                      <div className='flex gap-2 mr-2'>
                        <Field name='studentId'>
                          {({ field, meta }) => (
                            <TextField
                              size='small'
                              className='w-40'
                              variant='standard'
                              {...field} // Spreads name, value, onChange, and onBlur
                              InputProps={{
                                sx: {
                                  '& input:-webkit-autofill': {
                                    WebkitBoxShadow: '0 0 0 100px white inset',
                                  },
                                },
                              }}
                              fullWidth
                              // Error handling:
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                              onChange={(e) => {
                                field.onChange(e);
                                const value = e.target.value;
                                if (!value) setIsIdExists(false);
                              }}
                              onBlur={async (e) => {
                                field.onBlur(e);
                                if (e.target.value) {
                                  const res = await dispatch(
                                    SCIdCheck(e.target.value),
                                  ).unwrap();
                                  setIsIdExists(res);
                                } else {
                                  setIsIdExists(false);
                                }
                              }}
                            />
                          )}
                        </Field>
                      </div>
                      {isIdExists && (
                        <div
                          id='transactionIdError'
                          className='mb-2 text-red-600 text-sm text-center'
                        >
                          Admission No already Exists
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              {/* SC Body div */}
              <div className='font-serif bg-white text-[20px] leading-10 flex flex-col gap-1'>
                {/*Row 1*/}
                <div className='flex items-center gap-2'>
                  <span className="text-nowrap font-['Brush_Script_MT'] italic text-3xl">
                    This is to certify that Mr/Kum
                  </span>{' '}
                  <InputField name='studentName' />
                </div>
                {/* Row 2 */}
                <div className="text-nowrap font-['Brush_Script_MT'] italic text-3xl flex items-center gap-2">
                  <span className='text-nowrap'>Son of/Do/Sri/Smt</span>
                  <InputField name='guardianName' />
                </div>
                {/* Row 3 */}
                <div className="text-nowrap font-['Brush_Script_MT'] italic text-3xl flex items-center gap-2">
                  <span className='text-nowrap'>
                    a Pupil of this College Studied
                  </span>
                  <InputField name='className' />
                </div>
                {/* Row 4 */}
                <div className="text-nowrap font-['Brush_Script_MT'] italic text-3xl flex items-center gap-2">
                  <span>Class during the academic year</span>
                  <InputField name='academicYear' />
                </div>
                {/* Row 5 */}
                <div className="text-nowrap font-['Brush_Script_MT'] italic text-3xl  flex ">
                  <div>
                    In the said period his / her conduct and character were
                    found to be{' '}
                  </div>{' '}
                  <div>
                    <InputField name='conduct' />
                  </div>
                </div>

                {/* Signature */}
                <div className='flex justify-between mt-10'>
                  <div className='flex gap-4'>
                    <span className='text-nowrap'>Date : </span>{' '}
                    <DateField name='scDate' Tailwindwidth='w-40' />
                  </div>
                  <span>Seal</span>
                  <span>Principal</span>
                </div>
              </div>

              <div className='flex justify-between gap-12 mt-6'>
                <Button
                  variant='contained'
                  color='error'
                  type='button'
                  disabled={!values.id || isDownloading}
                  onClick={downloadSC}
                >
                  Print/Download
                </Button>{' '}
                <Button
                  variant='contained'
                  type='submit'
                  disabled={isIdExists || isSubmitting}
                >
                  Submit
                </Button>
              </div>
            </div>{' '}
          </Form>
        )}
      </Formik>
      <ToastNotification
        open={notification.open}
        onClose={hideNotification}
        message={notification.message}
        title={notification.title}
        severity={notification.severity}
        autoHideDuration={notification.autoHideDuration}
        position={notification.position}
      />
    </div>
  );
}

function InputField({ name, disabled = false, ...props }) {
  return (
    <Field name={name}>
      {({ field, meta }) => (
        <TextField
          {...props}
          size='small'
          disabled={disabled}
          variant='standard'
          {...field} // Spreads name, value, onChange, and onBlur
          fullWidth
          InputProps={{
            sx: {
              '& input:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px white inset',
              },
              '& input': {
                fontFamily: '"Times New Roman", serif',
                fontStyle: 'italic',
                fontWeight: 650,
                fontSize: '20px',
                textAlign: 'center',
              },
            },
          }}
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
        />
      )}
    </Field>
  );
}
import { useRef } from 'react';

function DateField({ name, disabled = false, Tailwindwidth = 'w-full' }) {
  const inputRef = useRef(null);

  const openPicker = () => {
    if (disabled) return;

    // Modern browsers
    if (inputRef.current?.showPicker) {
      inputRef.current.showPicker();
    } else {
      // Fallback
      inputRef.current.focus();
    }
  };

  return (
    <Field name={name}>
      {({ field, form, meta }) => (
        <div className='relative w-full font-sans'>
          {/* Hidden Actual Date Input */}
          <input
            ref={inputRef}
            type='date'
            disabled={disabled}
            {...field}
            onChange={(e) => {
              form.setFieldValue(name, e.target.value);
            }}
            className='absolute opacity-0 pointer-events-none'
          />

          {/* Clickable Dashed Line */}
          <div
            onClick={openPicker}
            className={`
              border-b border-gray-500
              min-h-[32px]
              cursor-pointer
              flex items-center justify-center
              px-1
               ${Tailwindwidth}
            `}
          >
            {field?.value
              ? new Date(field.value).toLocaleDateString('en-GB')
              : ''}
          </div>

          {/* Error */}
          {meta.touched && meta.error && (
            <div className='text-[#d32f2f] text-sm mt-1'>{meta.error}</div>
          )}
        </div>
      )}
    </Field>
  );
}
